import { axiosV3 } from "../../../Utils/Axios/axiosV3";

export const revokeUserDevice = (userToken: string, deviceId: string) => {
  return axiosV3.post(
    `/user/revoke-device`,
    {
      id: deviceId,
    },
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );
};
